import { useCallback } from 'react';
import { useLazyFetchDomainOverviewPdfQuery } from '../service';
import downloadPdfReport from '../downloadPdfReport';

export default function useDownloadDomainOverviewPdf() {
    const [fetchDomainOverviewPdf, { isFetching }] = useLazyFetchDomainOverviewPdfQuery();

    const downloadPdf = useCallback(
        (websiteGuid: string) => downloadPdfReport(() => fetchDomainOverviewPdf({ w_guid: websiteGuid }).unwrap()),
        [fetchDomainOverviewPdf]
    );

    return {
        downloadPdf,
        isDownloadingPdf: isFetching,
    };
}
